import { PublishMessageSetVersion, PublishMessageSetVersionVariables } from './__generated__/PublishMessageSetVersion'

import { gql } from 'apollo-boost'
import { useMutation } from '@apollo/react-hooks'

const MUTATION = gql`
  mutation PublishMessageSetVersion($input: PublishMessageSetVersionInputV2!) {
    publishMessageSetVersionV2(input: $input) {
      ... on MessageSetVersionErrorV2 {
        type
        error
      }
      ... on MessageSetVersionV2 {
        id
        title
        messageSetId
        messages {
          id
          text
          characters
          createdAt
          tags
          cardSize
        }
      }
    }
  }
`

export const usePublishMessageSetVersion = () =>
  useMutation<PublishMessageSetVersion, PublishMessageSetVersionVariables>(MUTATION)
